/**
 * Layout Header Height
 */
export const headerHeight = 48;

/**
 * Layout Footer Height
 */
export const footerHeight = 40;

/**
 * Sidebar Title Height
 */
export const sidebarTitleHeight = 52;

/**
 * Sider Trigger Height
 */
export const siderTriggerHeight = 40;

/**
 * Tabbar Height Height
 */
export const tabbarHeight = 35;

/**
 * @en Default namespace
 */
export const DEFAULT_NAMESPACE = "react-antd-admin";

/**
 * @en Main content element ID
 */
export const ELEMENT_ID_MAIN_CONTENT = `__${DEFAULT_NAMESPACE}_main_content`;

/**
 * @en Height of the layout content component
 */
export const CSS_VARIABLE_LAYOUT_CONTENT_HEIGHT = `--${DEFAULT_NAMESPACE}-content-height`;
/**
 * @en Width of the layout content component
 */
export const CSS_VARIABLE_LAYOUT_CONTENT_WIDTH = `--${DEFAULT_NAMESPACE}-content-width`;
/**
 * @en Height of the layout header component
 */
export const CSS_VARIABLE_LAYOUT_HEADER_HEIGHT = `--${DEFAULT_NAMESPACE}-header-height`;
/**
 * @en Height of the layout footer component
 */
export const CSS_VARIABLE_LAYOUT_FOOTER_HEIGHT = `--${DEFAULT_NAMESPACE}-footer-height`;
